import api from '@/api/index.js'

const distributors = {
  state: {
    loading: false,
    updating: false,
    data: [],
    single: null, // Represents single retrieved team
    error: null,
    distributorTypes: ['internal', 'external'],
    distributorClientStatuses: ['block', 'allow']
  },

  mutations: {
    SET_DISTRIBUTORS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_DISTRIBUTORS_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_DISTRIBUTORS: (state, teams) => {
      state.data = teams
      state.loading = false;
    },
    SET_DISTRIBUTOR: (state, d) => {
      state.single = d
      state.loading = false;
    },
    SET_DISTRIBUTOR_CREATED: (state, d) => {
      state.single = d
      state.loading = false;
    },
    CLEAR_DISTRIBUTOR_CREATED_SECRET: (state) => {
      if (state.single) {
        state.single.secret = ""
      }
    },
    SET_DISTRIBUTORS_ERROR: (state, error) => {
      state.error = error
    }
  },

  actions: {
    LoadDistributors({commit}) {
      commit('SET_DISTRIBUTORS_LOADING', true)
      commit('SET_DISTRIBUTORS_ERROR', null)
      return api.get('distributors?limit=150&offset=0')
        .then((response) => {
          commit('SET_DISTRIBUTORS', response)
        })
        .catch((error) => {
          commit('SET_DISTRIBUTORS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_DISTRIBUTORS_LOADING', false)
        })
    },
    GetDistributor({commit}, id) {
      commit('SET_DISTRIBUTORS_LOADING', true)
      commit('SET_DISTRIBUTORS_ERROR', null)
      commit('SET_DISTRIBUTOR', null)
      return api.get(`distributors/${id}`)
        .then((response) => {
          commit('SET_DISTRIBUTOR', response)
        })
        .catch((error) => {
          commit('SET_DISTRIBUTORS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_DISTRIBUTORS_LOADING', false)
        })
    },
    CreateDistributor({commit}, payload) {
      commit('SET_DISTRIBUTORS_UPDATING', true);
      commit('SET_DISTRIBUTORS_ERROR', null)
      commit('SET_DISTRIBUTOR_CREATED', null)
      return api.post(`distributors`, payload)
        .then((response) => {
          commit('SET_DISTRIBUTOR_CREATED', response.body)
          commit('SET_DISTRIBUTORS_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_DISTRIBUTORS_ERROR', error)
          commit('SET_DISTRIBUTORS_UPDATING', false);
        })
    },
    UpdateDistributor({commit}, payload) {
      commit('SET_DISTRIBUTORS_UPDATING', true);
      commit('SET_DISTRIBUTORS_ERROR', null)
      return api.put(`distributors/${payload.id}`, payload.data)
        .then((response) => {
          commit('SET_DISTRIBUTOR', response.body)
          commit('SET_DISTRIBUTORS_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_DISTRIBUTORS_ERROR', error)
          commit('SET_DISTRIBUTORS_UPDATING', false);
        })
    },
    DeleteDistributor({commit}, id) {
      commit('SET_DISTRIBUTORS_UPDATING', true);
      commit('SET_DISTRIBUTORS_ERROR', null)
      return api.delete(`distributors/${id}`)
        .then((response) => {
          commit('SET_DISTRIBUTORS_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_DISTRIBUTORS_ERROR', error)
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_DISTRIBUTORS_UPDATING', false);
        })
    },
    ClearCreated({commit}) {
      commit('CLEAR_DISTRIBUTOR_CREATED_SECRET', null)
    }
  }
}

export default distributors
